import type { MultiVoucherGroupedType, MultiVoucherSelectedType } from 'app/src/model'
import { euroFormatter } from 'app/src/shared/helpers'
import { Button } from 'primereact/button'
import { type ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

export function MultiVoucherUsageVoucherItem(props: {
  voucher: MultiVoucherSelectedType & MultiVoucherGroupedType
  onVoucherQuantityChange: (selectedQuantity: number) => void
}): ReactElement {
  const { voucher, onVoucherQuantityChange } = props

  const { t } = useTranslation('shopping', { keyPrefix: 'Direct.MultiVoucher.Usage' })

  return (
    <div
      className={`depth-8 grid min-h-[100px] grid-rows-3 items-center justify-center bg-[var(--card-background)] p-3 md:flex md:flex-row md:justify-around md:p-0`}
    >
      <div className='flex flex-row md:block'>
        <p className='p-[4px 0] m-0 pb-1'>{t('Funnel.Steps.VoucherSelection.voucherCounterTitle')}</p>
        <p className='m-0 pl-2 font-bold md:pl-0'>{euroFormatter.format(voucher.value)}</p>
      </div>
      <div className='flex flex-row md:block'>
        <p className='p-[4px 0] m-0 pb-1'>{t('Funnel.Steps.VoucherSelection.availableVouchers')}</p>
        <p className='m-0 pl-2 font-bold md:pl-0'>{voucher.availableQuantity}</p>
      </div>
      <div className='flex flex-row text-left md:block'>
        <p className='p-[4px 0] m-0 pb-1'>{t('Funnel.Steps.VoucherSelection.usedVouchers')}</p>
        <div className='items-left justify-left flex pl-2 md:pl-0'>
          <Button
            icon='pi pi-minus'
            className='h-[28px] w-[36px] px-[4px]'
            outlined
            aria-label={t('Funnel.Steps.VoucherSelection.decreaseVoucherAriaLabel', {
              VOUCHERVALUE: euroFormatter.format(voucher.value),
            })}
            disabled={voucher.availableQuantity === 0 || voucher.selectedQuantity === 0}
            onClick={() => onVoucherQuantityChange(voucher.selectedQuantity - 1)}
          />

          <p className='m-auto min-w-[30px] text-center'> {voucher.selectedQuantity} </p>

          <Button
            icon='pi pi-plus'
            className='h-[28px] w-[36px] px-[4px]'
            disabled={voucher.selectedQuantity === voucher.availableQuantity}
            onClick={() => onVoucherQuantityChange(voucher.selectedQuantity + 1)}
            aria-label={t('Funnel.Steps.VoucherSelection.increaseVoucherAriaLabel', {
              VOUCHERVALUE: euroFormatter.format(voucher.value),
            })}
          />
        </div>
      </div>
    </div>
  )
}
